import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import CustomEase from 'gsap/CustomEase'
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, CustomEase)

function banner() {
    const banner_arrow = document.querySelector('[data-target="banner_arrow"]')

    if (!banner_arrow) {
        return
    }

    gsap.set(banner_arrow, {autoAlpha:1, scale:0})
    banner_arrow.addEventListener('click', () => {
        const firstBlock = document.querySelector('[data-block-number="1"]')
        if (!firstBlock) return

        gsap.to(window, {
            duration: 1,
            scrollTo: {
                y: firstBlock,
                offsetY: 50,
            },
            ease: 'power2.inOut',
        })
    })
    
}

function bannerArrowLanding() {
    const banner_arrow_landing = document.querySelector('[data-target="banner_arrow_landing"]')

    if (!banner_arrow_landing) {
        return
    }

    gsap.set(banner_arrow_landing, {autoAlpha:1, scale:1})
    banner_arrow_landing.addEventListener('click', () => {
        const firstBlock = document.querySelector('#scroll_imgtxt')
        if (!firstBlock) return

        gsap.to(window, {
            duration: 1,
            scrollTo: {
                y: firstBlock,
                offsetY: 16,
            },
            ease: 'power2.inOut',
        })
    })
}

function bannerNews() {
    const banner_news = document.querySelector('[data-name="banner--news"]')

    if (!banner_news) return;

    // Initialize grid animation for featured article
    const featuredArticle = document.querySelector('[data-name="featured-article"]');
    if (featuredArticle && featuredArticle.classList.contains('grid_banner_anim_news')) {
        gsap.set(featuredArticle, {
            autoAlpha: 1
        });
        
        // Get grid items
        const gridItems = featuredArticle.querySelector('.grid__item');
        
       
        
        gsap.timeline({
            defaults: {
                duration: 1.5,
                delay: 0.5,
                ease: CustomEase.create("custom", "M0,0 C0.856,0 0.095,1.004 1,1 "),
            },
           
        })
        .fromTo(
            gridItems.querySelector('.grid__item-img'),
            {
                scale: 0,
                transformOrigin: `top right`,
            },
            {
                scale: 1,
            }
        )
        .fromTo(
            gridItems.querySelector('.grid__item-img-inner'),
            {
                scale: 3,
                transformOrigin: `top right`,
            },
            {
                scale: 1,
            },
            0
        )
        .to('[data-name="banner_content"]', {
            opacity: 1,
            duration: 1,            
            ease: 'none',
        },"-=1")
    }

    // Original banner news functionality
    gsap.to(
        "[data-name='banner-news-fade']",
        {
            autoAlpha: 1,
            duration: 1,
            stagger:0.3,
            ease: 'none',
        }
    )
    
    const searchInput = document.querySelector(
        '.search-filter-input-text__input'
    )
    const originalFetch = searchInput.fetch

    searchInput.fetch = async function (...args) {
        const response = await originalFetch.apply(this, args)

        response
            .clone()
            .text()
            .then(() => {
                const featuredArticle = document.querySelector(
                    '[data-name="featured-article"]'
                )

                if (featuredArticle) {
                    if (!searchInput.value.trim()) {
                        featuredArticle.style.display = 'flex'
                    } else {
                        featuredArticle.style.display = 'none'
                    }
                }
            })

        return response
    }
}

function bannerAnimation() {
    const grid_banner_anim = document.querySelector('.grid_banner_anim')

    if (!grid_banner_anim) {
        return
    }
    

    gsap.set(grid_banner_anim, {
        autoAlpha: 1
     })
    // Get all grid items within the grid
    const gridItems = grid_banner_anim.querySelectorAll('.grid__item');

   
   
    const viewportHeight = window.innerHeight;
    const endValue = viewportHeight / 2;


     gsap.set('main', {autoAlpha:0})
    gsap.to('[data-name="banner_content"]', {
        opacity: 1,
        delay: window.innerWidth > 992 ? 1 : 2.3,
        duration: 0.5,
        ease: 'none',
    })

    // Check if banner_discover exists and animate it
    const bannerDiscover = document.querySelector('[data-name="banner_discover"]');
    if (bannerDiscover) {
        gsap.to(bannerDiscover, {
            opacity: 1,
            delay: window.innerWidth > 992 ? 2 : 2.5,
            duration: 0.5,
            ease: 'none',
        });
    }
    gsap.to('main', {
        opacity: 1,
        visibility: 'visible',
        delay: 2,
        duration: 0.5,
        ease: 'none',
    })


    // Loop through each grid item to add animations
    gridItems.forEach((item, index) => {
        // Get the previous element sibling for the current item
        const previousElementSibling = item.previousElementSibling;
        // Determine if the current item is on the left side based on its position relative to the previous item
        const isLeftSide = previousElementSibling && (item.offsetLeft + item.offsetWidth <= previousElementSibling.offsetLeft + 1);
        // Determine the origin for transformations (either 100 or 0 depending on position)
        const originX = isLeftSide ? 100 : 0;
        
        
        gsap
    .timeline({
        defaults: {
            duration: 1.5,
            ease: CustomEase.create("custom", "M0,0 C0.856,0 0.095,1.004 1,1 "),
        },
        delay: index * 1.3, // Add delay based on index to stagger
      
    })
    
    .fromTo(
        item.querySelector('.grid__item-img'),
        {
            scale: 0,
            transformOrigin: `${originX}% 0%`,
        },
        {
            scale: 1,
        }
    )
    .fromTo(
        item.querySelector('.grid__item-img-inner'),
        {
            scale: 3,
            transformOrigin: `${originX}% 0%`,
        },
        {
            scale: 1,
        },
        0
    )
    if (index === 0) {
        gsap.to('[data-target="banner_arrow"]', {
            scale: 1,
            duration: 1.2,
            transformOrigin: document.querySelector('.grid_banner_anim_single') ? 'top left' : 'bottom left',
            delay: !document.querySelector('.grid_banner_anim_single') ? 1 : 0,
            ease: CustomEase.create("custom", "M0,0 C0.856,0 0.095,1.004 1,1 "),
        }, "-=1.4")
    }
        
    });

   


    
}

function bannerAnimationBlue() {
    const grid_banner_anim = document.querySelector('.grid_banner_anim_blue')

    if (!grid_banner_anim) {
        return
    }
    

    gsap.set(grid_banner_anim, {
        autoAlpha: 1
     })
    // Get all grid items within the grid
    const gridItems = grid_banner_anim.querySelectorAll('.grid__item');

   
   
    const viewportHeight = window.innerHeight;
    const endValue = viewportHeight / 2;


     gsap.set('main', {autoAlpha:0})
    gsap.to('[data-name="banner_content"]', {
        opacity: 1,
        delay: 1.5,
        duration: 0.5,
        ease: 'none',
    })
    gsap.to('main', {
        opacity: 1,
        visibility: 'visible',
        delay: 2,
        duration: 0.5,
        ease: 'none',
    })

    // Check for skip links and animate if present
    const skipLinks = document.querySelector('[data-name="skip_links"]');
    if (skipLinks) {
        gsap.to(skipLinks, {
            opacity: 1,
            delay: 1.7,
            duration: 0.5,
            ease: 'none',
        })
    }


    // Loop through each grid item to add animations
    gridItems.forEach((item, index) => {
        
        
        
        gsap
    .timeline({
        defaults: {
            duration: 1.5,
            ease: CustomEase.create("custom", "M0,0 C0.856,0 0.095,1.004 1,1 "),
        },
        delay: index * 1.3, // Add delay based on index to stagger
      
    })
    
    .fromTo(
        item.querySelector('.grid__item-img'),
        {
            scale: 0,
            transformOrigin: `top right`,
        },
        {
            scale: 1,
        }
    )
    .fromTo(
        item.querySelector('.grid__item-img-inner'),
        {
            scale: 3,
            transformOrigin: `top right`,
        },
        {
            scale: 1,
        },
        0
    )
    
        
    });

   


    
}

export { banner, bannerNews, bannerAnimation, bannerAnimationBlue, bannerArrowLanding }
